var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "Back" },
              on: {
                click: function($event) {
                  return _vm.$emit("back")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
          ),
          _c("span", { staticStyle: { "margin-left": "15px" } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CombinationPlanQuery")))
          ]),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "15px" },
              attrs: { disabled: _vm.active === 1, no: "trunkLineEnable" },
              model: {
                value: _vm.filter.trunkLineEnable,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "trunkLineEnable", $$v)
                },
                expression: "filter.trunkLineEnable"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainlinePrice")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: {
                disabled:
                  _vm.active === 1 ||
                  _vm.type ===
                    _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code,
                no: "prePortEnable"
              },
              on: { change: _vm.prePortEnableChange },
              model: {
                value: _vm.filter.prePortEnable,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "prePortEnable", $$v)
                },
                expression: "filter.prePortEnable"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrePortPrice")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.active === 1, no: "lastMileEnable" },
              on: { change: _vm.lastMileEnableChange },
              model: {
                value: _vm.filter.lastMileEnable,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "lastMileEnable", $$v)
                },
                expression: "filter.lastMileEnable"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LastMilePrice")))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-steps",
            { attrs: { active: _vm.active, "finish-status": "success" } },
            [
              _c("el-step", {
                attrs: { title: _vm.$t("CargoMsg.Cargo_FillQueryConditions") }
              }),
              _c("el-step", {
                attrs: { title: _vm.$t("CargoMsg.Cargo_SelectMatchingRate") }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.active === 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "generateCombinationPlan" },
                  on: { click: _vm.generateCombinationPlan }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_GenerateCombinationPlan"))
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.active === 0
        ? _c("price-combination-step1", {
            attrs: { type: _vm.type, filter: _vm.filter }
          })
        : _vm._e(),
      _vm.active === 1
        ? _c("price-combination-step2", {
            ref: "priceCombinationStep2",
            attrs: {
              type: _vm.type,
              "trunk-line-enable": _vm.filter.trunkLineEnable,
              "pre-port-enable": _vm.filter.prePortEnable,
              "last-mile-enable": _vm.filter.lastMileEnable,
              "trunk-line-data": _vm.trunkLineData,
              "pre-port-data": _vm.prePortData,
              "last-mile-data": _vm.lastMileData,
              "trunk-line-data-total": _vm.trunkLineDataTotal,
              "pre-port-data-total": _vm.prePortDataTotal,
              "last-mile-data-total": _vm.lastMileDataTotal
            },
            on: { pagination: _vm.pagination }
          })
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "center" } },
        [
          _vm.active === 0
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "next" },
                  on: { click: _vm.next }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Next")))]
              )
            : _vm._e(),
          _vm.active === 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "backToPreviousStep" },
                  on: { click: _vm.backToPreviousStep }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnToPreviousStep")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }